import web from "../src/images/img2.jpg";
import web2 from "../src/images/img4.png";
import web3 from "../src/images/img3.jpg";




const Sdata = [
    {
        imgsrc: web,
        title: "Web development",
    },
    {
        imgsrc: web2,
        title: "App Development",
    },
    {
        imgsrc: web3,
        title: "Machine Learning",
    },
    {
        imgsrc: web2,
        title: "Artificial Inteligence",
    },
    {
        imgsrc: web3,
        title: "Software development",
    },
    {
        imgsrc: web,
        title: "Mobile development",
    },
];

export default Sdata;